<template>
  <div class="app flex-row align-items-center">
    <vue-progress-bar></vue-progress-bar>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>{{ $t('login.login_title') }}</h1>
                <span class="text-muted">{{ $t('login.login_description') }}</span>
                <div class="clearfix"></div>
                <span v-show="error != null" class="text-danger">{{ error }}</span>
                <div class="clearfix"><br/></div>
                <b-form class="container" v-on:keydown.enter="submit">
                  <b-form-group>
                    <b-input-group class="mb-3">
                      <div class="input-group-prepend"><span class="input-group-text"><i class="icon-user"></i></span>
                      </div>
                      <b-form-input type="email" class="form-control" v-model="form.email"
                                    v-bind:placeholder="$t('login.email')" :state="!$v.form.email.$invalid"
                                    aria-describedby="email-feedback"/>
                      <b-form-invalid-feedback id="email-feedback">
                        {{ $t('message.required_email_filed') }}
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                  <b-input-group class="mb-4">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="icon-lock"></i>
                      </span>
                    </div>
                    <b-form-input :type="password_type" class="form-control" v-model="form.password"
                                  v-bind:placeholder="$t('login.password')" :state="!$v.form.password.$invalid"
                                  aria-describedby="password-feedback"/>
                    <b-input-group-append>
                      <span class="input-group-text show-password" @mousedown="showPass" @mouseleave="hidePass" @mouseup="hidePass" @touchstart="showPass" @touchend="hidePass" @touchcancel="hidePass">
                        <i class="fa fa-eye"></i>
                      </span>
                    </b-input-group-append>

                    <b-form-invalid-feedback id="password-feedback">
                      {{ $t('message.password_complex') }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col cols="5">
                      <b-button @click="submit" variant="dark" class="px-4" id="btn-login" :disabled="$v.form.$invalid">
                        {{ $t('login.login_title') }}
                      </b-button>
                    </b-col>
                    <b-col cols="7" class="text-right">
                      <router-link to="/forgot-password" class=" text-dark t15 " style="text-decoration:none">
                        {{$t('login.forgot_password')}}
                      </router-link>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-dark py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center login-card-body">
                <div>
                  <div class="login-language">
                  </div>
                  <div class="clearfix"></div>
                  <img src="https://phjp.s3-ap-northeast-1.amazonaws.com/logo/logo_wide_white%40x2.png" class="login-logo" alt="GMS">
                  <p>

                  </p>
                  <div class="login-copyright">Fusion © {{ getCurrentYear }}</div>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
  .login-language {
    width: 100px;
    float: right;
    margin-top: -10px;
  }

  .login-card-body {
    padding-top: 0px !important;
    margin-top: -20px !important;
  }

  .login-logo {
    width: 85%;
    margin-bottom: 20px;
  }

  .login-copyright {
    margin-top: 40px;
    margin-bottom: -30px;
  }

  .show-password {
    cursor: pointer;
  }
</style>

<script>
  import ChangeLanguage from '../../components/Partials/ChangeLanguages.vue'
  import {validationMixin} from 'vuelidate'
  import {required, email} from 'vuelidate/lib/validators'
  import Vue from 'vue'
  import * as Cookies from 'js-cookie'

  export default {
    name: 'Login',
    components: {
      ChangeLanguage
    },
    data () {
      return {
        form: {},
        error: null,
        password_type: 'password'
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      form: {
        password: {
          required,
          strongPassword(password) {
            return (
                    /[A-Z]/.test(password) && // checks for A-Z
                    /[a-z]/.test(password) && // checks for a-z
                    /[0-9]/.test(password) && // checks for 0-9
                    password.length >= 6
            )
          }
        },
        email: {
          required,
          email
        }
      }
    },
    methods: {
      showPass: function () {
        this.password_type = 'text'
      },
      hidePass: function () {
        this.password_type = 'password'
      },
      submit: function () {
        this.$Progress.start()
        this.axios.tenant.checkUser(this.form, (res) => {
          if (res && res.data && res.data.data) {
            let lang = 'en'
            if (res.data.data.clients.length === 1 && res.data.data.clients.indexOf(1) !== -1) {
              lang = 'ja'
            }
              
            this.$store.dispatch('setLang', lang)
            this.$session.set('lang', lang)
            Vue.axios.defaults.headers.common['Lang'] = lang
            this.$store.commit('setLang', lang)
            this.$root.$emit('changeLang')
            this.$router.push({name: 'CheckOtp', params: {uuid: res.data.data.uuid}})
            
          }
        }, error => {
          console.log(error)
          this.$Progress.fail()
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/Login.vue